import { render, staticRenderFns } from "./eduVoteList.vue?vue&type=template&id=45e9d503&scoped=true&"
import script from "./eduVoteList.vue?vue&type=script&lang=js&"
export * from "./eduVoteList.vue?vue&type=script&lang=js&"
import style0 from "./eduVoteList.vue?vue&type=style&index=0&id=45e9d503&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45e9d503",
  null
  
)

export default component.exports